<template>
  <Modal v-model="visible" :width="960" title="批量推送" @on-visible-change="bindGetData">
    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <span class="item-field">已选DMP包</span>
      </Col>
      <Col span="12" style="margin-top: 18px; width: 70%; min-height: 40px">
        <Spin size="large" fix v-if="dmpLoading" />
        <div v-else v-for="(item, index) in dmpList" :key="item.packageId" style="display: inline-block; font-size: 14px">
          <span :class="{ unAvailDmp: item.dmpStatus === 2 }">{{ item.dmpName }}</span>
          <span v-if="index != dmpList.length - 1">,</span>
        </div>
        <div style="color: #ff6400">说明：置灰的人群包不可用，不能进行推送</div>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <span class="item-field">媒体</span>
      </Col>
      <Col span="12">
        <RadioGroup v-model="mediaId" type="button" @on-change="handleChangeMedia">
          <Radio :label="16">腾讯</Radio>
          <Radio :label="10">巨量引擎</Radio>
          <Radio :label="45">百度信息流</Radio>
          <Radio :label="32">磁力引擎</Radio>
          <Radio :label="6">超级汇川</Radio>
        </RadioGroup>
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <span class="item-field">账号</span>
      </Col>
      <Col span="16">
        <Input search v-model="keyword" placeholder="请输入计划账号名称/计划主ID" style="width: 300px" @on-search="search" />
      </Col>
    </Row>
    <Row class="row-item" :gutter="12">
      <Col span="4" class="col-item">
        <!-- <span class="item-field">账号</span> -->
      </Col>
      <Col span="16" style="min-height: 410px">
        <!-- <Spin size="large" fix v-if="loading" /> -->
        <select-account
          v-model="checkedList"
          :checkedList="checkedList"
          :data="accountIdList"
          :loading="loading"
          @on-clear="clearAll"
          @on-check="checkItem"
          @select-all="selectAll"
        />
      </Col>
    </Row>
    <div slot="footer" style="bottom: 0">
      <Button type="text" size="large" @click="cancel">取消</Button>
      <Button type="primary" size="large" @click="submit">确定</Button>
    </div>
  </Modal>
</template>
<script>
import { isArray, deepCopy } from '@/common/js/utils'
import { adAccount } from '@/api/common.model'
import { dmpCheck } from '@/api/manage.model'
import SelectAccount from './select/select-account'
export default {
  name: 'SetBatch',
  components: {
    SelectAccount
  },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  data() {
    return {
      loading: null,
      dmpLoading: null,
      accountIdList: [],
      packageIdList: [],
      keyword: '',
      dmpList: [],
      mediaId: 16,
      checkedList: []
    }
  },
  methods: {
    bindGetData(val) {
      if (val) {
        this.packageIdList = this.data.map((e) => {
          return e.id
        })
        this.preLoadData()
      } else {
        this.mediaId = 16
        this.keyword = ''
        this.checkedList = []
      }
    },
    preLoadData() {
      this.loading = true
      this.dmpLoading = true
      Promise.all([
        adAccount({
          mediaId: this.mediaId,
          authFlag: 1
        }),
        dmpCheck({
          mediaId: this.mediaId,
          packageIdList: this.packageIdList
        })
      ])
        .then((data) => {
          this.loading = false
          this.dmpLoading = false
          if (isArray(data) && data.every((ret) => isArray(ret))) {
            const [accountIdList, dmpList] = data
            this.accountIdList = accountIdList
            this.dmpList = dmpList
          } else {
            console.error('error！')
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    handleChangeMedia() {
      this.keyword = ''
      this.checkedList = []
      this.preLoadData()
    },
    clearAll() {
      this.accountIdList.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      this.checkedList = []
    },
    selectAll(check) {
      this.accountIdList.forEach((ret) => {
        this.$set(ret, 'check', check)
      })
      this.checkedList = check ? deepCopy(this.accountIdList) : []
    },
    checkItem(item) {
      let isDul = false // 查重
      this.checkedList &&
        this.checkedList.forEach((ret) => {
          if (ret.id === item.id) isDul = true
        })
      if (item.check && !isDul) this.checkedList.push(item)
      else if (!item.check && isDul) {
        const checkList = this.checkedList
        checkList.forEach((ret, index) => {
          if (ret.id === item.id) this.checkedList.splice(index, 1)
        })
      }
    },
    submit() {
      const packageIdList = []
      const accountIdList = []
      this.dmpList.forEach((ret) => {
        if (ret.dmpStatus === 1) packageIdList.push(ret.packageId)
      })
      this.checkedList.forEach((ret) => accountIdList.push(ret.id))
      const params = {
        packageIdList,
        accountIdList,
        mediaId: this.mediaId
      }
      if (!packageIdList.length) {
        this.$Message.error('当前选择DMP包不可推送，请重新选择！')
      } else if (!this.checkedList.length) {
        this.$Message.error('请选择账号进行推送')
      } else {
        this.$emit('on-submit', params)
      }
    },
    search() {
      this.loading = true
      adAccount({
        mediaId: this.mediaId,
        authFlag: 1,
        keyword: this.keyword
      }).then((data) => {
        this.loading = false
        this.accountIdList = data
        this.accountIdList.forEach((ret) => {
          this.checkedList.forEach((item) => {
            if (item.id === ret.id) {
              this.$set(ret, 'check', true)
            }
          })
        })
      })
    },
    cancel() {
      this.$emit('on-cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .unAvailDmp {
  color: #bbb;
}

::v-deep .ivu-modal-content {
  overflow-x: hidden;
  overflow-y: scroll;
  min-height: 720px;
}
</style>
